import { inject, injectable } from "../injection";
import { MessageBusService } from "./MessageBusService";
import { observable, action, makeObservable } from "mobx";
import { ITimedOutRequest } from "./MessageBusClient";
import isEqual from "lodash/isEqual";

@injectable("singleton")
export class TimeoutNoticeStore {
    @observable.ref public requests: ITimedOutRequest[] = [];

    constructor(
        @inject(MessageBusService) private messageBusService: MessageBusService
    ) {
        makeObservable(this);

        this.messageBusService
            .getClient()
            .subscribeToTimeoutNotices(this.updateRequests);
    }

    @action private updateRequests = (requests: ITimedOutRequest[]): void => {
        if (!isEqual(requests, this.requests)) {
            this.requests = requests;
        }
    };

    public onKeepWaitingClick = (): void => {
        this.messageBusService
            .getClient()
            .resetRequestTimeouts(this.requests.map(x => x.id));
    };

    public onStopProcessClick = (): void => {
        this.messageBusService
            .getClient()
            .killRequestTimeouts(this.requests.map(x => x.id));
    };
}
